import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'
import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'

const DEFAULT_STATE = {
  loading: false,
  actionLoading: false,

  items: [],
  page: 1,
  limit: 10,
  total: null,
  search: null,

  sort: {
    sort_by: SORT_ORDER.APPROVED_COUNT,
    sort_direction: SORT_DIRECTION.ASC,
  },

  terms_accepted: null,
}

export default {
  ...DEFAULT_STATE,
}
